import { Component, OnInit } from '@angular/core';
import { OverlayService } from '@miq/stacking-plan';

@Component({
  selector: 'miq-availability-agreement-date',
  template: `
    <div class="overlay">
      <p>
        <label l10nTranslate>recordsSearch.agreementSignedDate</label>
        <span> {{ row.agency_agreement_sign_date ? (row.agency_agreement_sign_date | date: 'dd/MM/yyyy') : '-' }}</span>
      </p>
      <p>
        <label l10nTranslate>recordsSearch.agreementStartDate</label>
        <span>
          {{ row.agency_agreement_start_date ? (row.agency_agreement_start_date | date: 'dd/MM/yyyy') : '-' }}</span
        >
      </p>
      <p>
        <label l10nTranslate>recordsSearch.agreementEndDate</label>
        <span> {{ row.agency_agreement_end_date ? (row.agency_agreement_end_date | date: 'dd/MM/yyyy') : '-' }}</span>
      </p>
    </div>
  `,
  styles: [
    `
      .overlay {
        width: 300px;
        height: 100px;
        border: solid 1px #ccc;
        background: #fff;
      }

      .overlay p {
        margin: 10px;
      }

      .overlay label {
        font-size: 13px;
        font-family: $primary-lightbold;
      }
      .overlay span {
        font-size: 13px;
        font-family: $primary-font;
      }
    `,
  ],
  standalone: false,
})
export class AvailabilityAgreementDateComponent implements OnInit {
  row: any;
  constructor(private overlayService: OverlayService) {}

  ngOnInit() {
    const { row } = this.overlayService.overlayDialogData;
    this.row = row;
  }
}

export const showOverlay = (overlayService, event, rowDetails) => {
  overlayService.openOverlayBox(AvailabilityAgreementDateComponent, { row: rowDetails }, event);
};
